import { createSelector } from 'reselect';
var selectActionState = function (state) { return state.get('action'); };
export var isRequestingInProgress = createSelector(selectActionState, function (actionState) { return actionState.get('requesting'); });
export var selectOrderNumber = createSelector(selectActionState, function (actionState) { return actionState.get('orderNumber'); });
